import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=24d60216&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=js&"
export * from "./AddressList.vue?vue&type=script&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=24d60216&prod&lang=scss&scoped=true&"
import style1 from "./AddressList.vue?vue&type=style&index=1&id=24d60216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d60216",
  null
  
)

export default component.exports